import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FiscalHomePillComponent } from './components/fiscal-home-pill/fiscal-home-pill.component';
import { FiscalStatusPillComponent } from './components/fiscal-status-pill/fiscal-status-pill.component';

/**
 * Piezas del onboarding fiscal que se usan FUERA del módulo lazy (patrón `CreditosSharedModule`):
 *   - `FiscalHomePillComponent`: píldora de la cabecera del Home (`DashboardModule`).
 *   - `FiscalStatusPillComponent`: badge del ítem «Fiscal» del menú (`NavigationModule`) y la página.
 * `FiscalOnboardingModule` (lazy) lo importa; no vuelve a declararlos.
 */
@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [FiscalHomePillComponent, FiscalStatusPillComponent],
    exports: [FiscalHomePillComponent, FiscalStatusPillComponent],
})
export class FiscalOnboardingSharedModule {}
